<template>
  <header-bar></header-bar>
  <div id="top-content-buffer"></div>
  <div class="page-container">
    <div class="page-content">
      <router-view />
    </div>
  </div>
</template>

<!--<template>
  <amplify-authenticator>
    <div>
      My App
      <amplify-sign-out></amplify-sign-out>
    </div>
  </amplify-authenticator>
</template>
-->
<script>
import { AllCommunityModules } from 'ag-grid-community';
import HeaderBar from '@/components/header-bar.vue';
import { Auth } from 'aws-amplify';

export default {
  name: 'App',
  mixins: [],
  components: {
    HeaderBar,
  },
  data() {
    return {
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      frameworkComponents: null,
      defaultColDef: null,
      modules: AllCommunityModules,
      rowData: null,
    };
  },
  created() {
    if (!this.isUserAuthenticated()) {
      this.$router.push({ path: '/' });
    }
  },
  methods: {
    async isUserAuthenticated() {
      try {
        console.log('Testing to see if the user is authenticated.');
        const userObj = await Auth.currentAuthenticatedUser();
        console.log(userObj);
      } catch (err) {
        console.log(err);
      }
    },
  },

};
</script>

<style lang="scss">
@import '@/design/index.scss';
.button.is-secondary {
  background-color: $secondary !important;
  color: $primary !important;
}
.pri-color {
  color: $pri-color;
}
.pri-bg {
  background-color: $pri-bg;
  color: #fff;
}
.sec-bg {
  background-color: $sec-bg;
  color: $pri-color;
}
.size1-text {
  font-size: 22px;
  font-weight: 600;
}
.size2-text {
  font-size: 18px;
  font-weight: 600;
}
.app-green {
  color: $app-green;
}
.app-red {
  color: $app-red;
}
.app-yellow {
  color: $app-yellow;
}
#app {
  display: flex;
  flex-flow: column;
  /*height: 100%;*/
  background-color: #333;
}
#top-content-buffer {
  background-color: #FBBB00;
  height: 8px;
  margin-left: 140px;
  margin-right: 140px;
}
.navbar-menu {
  background-color: #333;
}
.page-container {
  background-color: #fff;
  margin-left: 140px;
  margin-right: 140px;
  flex-grow: 1;
}
.page-content {
  background-color: #fff;
  padding: 10px 30px;
}
.page-header {
  border-bottom: 1px solid #949494;
  padding-top: 10px;
  padding-bottom: 15px;
  margin-bottom: 14px !important;
}
.page-heading-label {
    font-weight: 600;
    margin-top: 12px;
    line-height: 1.75;
    text-align: right;
    min-width: 180px;
}
.page-heading-total-amount {
    font-size: 28px;
    font-weight: 600;
    margin-right: 10px;
    text-align: right;
}
.breadcrumb {
  font-size: 1em;
}
.breadcrumb-wrapper {
  margin-bottom: 20px;
}

@media only screen and (max-width: 1024px) {
  .page-container {
    margin-left: 20px;
    margin-right: 20px;
  }
  #top-content-buffer {
    margin-left: 20px;
    margin-right: 20px;
  }
  .page-content {
    margin-left: 8px;
    margin-right: 8px;
  }

}

</style>
